<div
  class="rounded-2xl bg-slate-100 border-2 border-dashed border-slate-300 p-10 text-center"
>
  <h2 class="text-xl font-bold text-slate-700">Survey Expired</h2>
  <p class="text-slate-500 mt-2">This link is no longer active.</p>
</div>
